import config from '../../../config'

import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { MdDownload, MdSearch, MdReport } from 'react-icons/md'
import { useCookies } from 'react-cookie'

import useAlert from '../../../stores/useAlert'

import LoadingSpinner from '../../../components/Misc/LoadingSpinner'
import { SkipAdsModal } from '../../../components/Model'

import MoreFrom from './MoreFrom'

import fetchModel from '../api/fetchModel'
import reportBrokenLink from '../api/reportBrokenLink'

import useIsAuthenticated from '../../../customhooks/useIsAuthenticated'

import isDateWithinLast30Days from '../../../utils/isDateWithinLast30Days'


const Profile = () => {
    const isAuthenticated = useIsAuthenticated()
    const setAlert = useAlert((state) => state.setAlert)
    const hideAlert = useAlert((state) => state.hideAlert)

    const { slug_url } = useParams()
    const [cookies, setCookie, removeCookie] = useCookies()

    const [isLoading, setIsLoading] = useState(false)
    const [modelProfile, setModelProfile] = useState({
        id: 0,
        name: '',
        image: '',
        slugUrl: '',
        createdAt: ''
    })
    const [moreFrom, setMoreFrom] = useState([])
    const [showSkipAdsModal, setShowSkipAdsModal] = useState(false)

    const [isReportBrokenLinkDisabled, setisReportBrokenLinkDisabled] = useState(false)

    useEffect(() => {
        const fetchModelProfile = async () => {
            const response = await fetchModel(slug_url)

            if (response.data.error || response.data.data.length === 0) {
                window.location.replace('/')
            }

            if (!response.data.error) {
                document.title = `MagicFans - ${response.data.data.model.name}`

                setModelProfile({
                    id: response.data.data.model.id,
                    name: response.data.data.model.name,
                    image: response.data.data.model.image,
                    slugUrl: response.data.data.model.slug_url,
                    createdAt: response.data.data.model.created_at
                })
                setMoreFrom(response.data.data.more)
            }
        }

        fetchModelProfile()
    }, [])

    const handleReportBrokenLink = async () => {
        const response = await reportBrokenLink(modelProfile.id)

        setAlert(response.data.message)
        setisReportBrokenLinkDisabled(true)

    }
    return (
        <>
            {isLoading ?
                <LoadingSpinner /> :

                <>
                    <div className="container col-xl-10 px-4 pt-5">
                        <p className="col-lg-10 fs-4 text-white text-truncate">
                            {modelProfile.name}
                            {' '}
                            {isDateWithinLast30Days(new Date(modelProfile.createdAt)) &&
                                <p className="badge fs-6 special-button m-0">
                                    NEW
                                </p>
                            }
                        </p>
                        <hr className="solid" />
                        <div className="row g-lg-5 pt-1">
                            <div className="col-md-10 mx-auto col-lg-3 mb-3">
                                {/* <a href={`/generate-download/${modelProfile.slugUrl}`} className="btn btn-primary mb-3 w-100 rounded-4" target={'_blank'}>Download <MdDownload /></a> */}
                                {cookies.SkipAdsModalSeen ?
                                    <a href={`/generate-download/${modelProfile.slugUrl}`} className="btn btn-primary mb-3 w-100 rounded-4" style={{ width: '100%' }} target={'_blank'}>Download <MdDownload /></a> :
                                    <button className="btn btn-primary mb-3 w-100 rounded-4" style={{ width: '100%' }}
                                        onClick={() => {
                                            setShowSkipAdsModal(true)
                                            setCookie('SkipAdsModalSeen', 'true', {
                                                path: '/'
                                            })
                                        }}
                                    >Download <MdDownload /></button>
                                }

                                {isAuthenticated &&
                                    <>
                                        <a href={`/generate-download/${modelProfile.slugUrl}?ad_free=true`} className="btn btn-primary special-button" style={{ width: '100%' }} target={'_blank'}>Ad-free for 1 point</a>
                                        <hr className="solid" />
                                    </>
                                }

                                {moreFrom.length > 0 &&
                                    <a href={'#more'} className="btn btn btn-outline-light mb-3 w-100 rounded-4">More From This Model <MdSearch /></a>
                                }

                                <button className="btn btn-outline-danger mb-3 w-100 rounded-4" disabled={isReportBrokenLinkDisabled} onClick={handleReportBrokenLink}>Report Broken Link <MdReport /></button>
                            </div>
                            <div className="col-lg-9 text-center text-lg-start">
                                <img src={!modelProfile.image ? config.PLACEHOLDER_IMAGE : modelProfile.image} className="img-fluid rounded-4" height="1080px" width="1080px" />
                            </div>
                        </div>
                    </div>

                    <MoreFrom
                        isLoading={isLoading}
                        moreFrom={moreFrom}
                    />
                </>

            }

            <SkipAdsModal
                setShowSkipAdsModal={setShowSkipAdsModal}
                show={showSkipAdsModal}
                slugUrl={modelProfile.slugUrl}
            />
        </>
    )
}

export default Profile